/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Info from 'DesignSystem/Info/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Email({
  children,
  viewPath = "/App/Auth/ResetPasswordConfirm/Email"
  
}) {
let flowShortcutsEmailValueData = fromData.useDataValue({ viewPath,
context: 'flow_shortcuts',
path: 'email',
})
  return (<React.Fragment
>
<Info
  viewPath={`${viewPath}/Info`}
 data="flow_shortcuts.email"
 text={flowShortcutsEmailValueData}
/>
{children}
</React.Fragment>)
}